"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),e=t.styled(t.Button)({maxWidth:384});exports.Button=e;
